export default function About() {
  return (
    <section id="about" className="py-20 sm:py-24 lg:py-32 border-t border-ink/5" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden border border-ink/5 shadow-[0_30px_80px_-40px_rgba(30,77,58,0.4)]">
            <img
              src="https://images.pexels.com/photos/35580718/pexels-photo-35580718.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="A quiet reading corner"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="text-[11px] sm:text-xs uppercase tracking-[0.2em] text-brand mb-3">About the journal</div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold leading-tight text-ink">
            We write the way our maps look. <span className="italic">Spacious, focused, and a little bit slow on purpose.</span>
          </h2>
          <p className="mt-5 sm:mt-6 text-base sm:text-lg text-ink-muted leading-relaxed">
            SummaryMaps is a tool for turning books into beautiful, interactive mind maps. This is the journal that sits beside it —
            a place for editor-picked essays on mindmaps, education, the books worth mapping, and the new releases we're reading
            this season.
          </p>
          <p className="mt-3 sm:mt-4 text-base sm:text-lg text-ink-muted leading-relaxed">
            No clickbait. No five-thousand-word listicles. Just compact, structured reading — the kind that ends with a
            one-page map you can keep.
          </p>

          <div className="mt-8 sm:mt-10 grid grid-cols-3 gap-4 sm:gap-6 max-w-md">
            <div>
              <div className="font-serif text-2xl sm:text-3xl text-brand">200+</div>
              <div className="text-[10px] sm:text-xs uppercase tracking-[0.15em] text-ink-subtle mt-1">Books mapped</div>
            </div>
            <div>
              <div className="font-serif text-2xl sm:text-3xl text-brand">4</div>
              <div className="text-[10px] sm:text-xs uppercase tracking-[0.15em] text-ink-subtle mt-1">Pillars</div>
            </div>
            <div>
              <div className="font-serif text-2xl sm:text-3xl text-brand">∞</div>
              <div className="text-[10px] sm:text-xs uppercase tracking-[0.15em] text-ink-subtle mt-1">Things to remember</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
